import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { useUserInformationManager, useUserTable } from "./hooks";
import { Placeholder, Table, UserMenu } from "./components";

export function UserInformationTable({ currentUser, ...props }) {
  const { loading, users, error, reloadData } = useUserTable();
  const { showColumn } = useUserInformationManager();

  useEffect(() => {
    reloadData();
  }, [currentUser, reloadData]);

  if (loading) {
    return (
      <Placeholder data-test="user-information-loader">
        <Placeholder.Header>
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
        </Placeholder.Header>
      </Placeholder>
    );
  }

  if (error) {
    return <div data-test="user-information-error">{error}</div>;
  }

  if (users.length === 0) {
    return (
      <div data-test="user-information">
        There are no users yet added for this practice&apos;s hub
      </div>
    );
  }

  return (
    <Table
      data-test="user-information-table"
      selectable={currentUser.role.title === "Administrator"}
      stackable
    >
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={3}>Name</Table.HeaderCell>
          <Table.HeaderCell width={3}>Email</Table.HeaderCell>
          <Table.HeaderCell width={3}>Permissions</Table.HeaderCell>
          <Table.HeaderCell width={3}>Status</Table.HeaderCell>
          {showColumn.insights && (
            <Table.HeaderCell width={3}>Insights</Table.HeaderCell>
          )}
          <Table.HeaderCell width={1} data-test="action-column-header" />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {users.map((user) => {
          return (
            <Table.Row key={user.id}>
              <Table.Cell>{user.name}</Table.Cell>
              <Table.Cell>{user.email}</Table.Cell>
              <Table.Cell>{user.role.title}</Table.Cell>
              <Table.Cell>{user.status}</Table.Cell>
              {showColumn.insights && (
                <Table.Cell>{user.insightsEnabled ? "Enabled" : ""}</Table.Cell>
              )}
              <Table.Cell data-test="action-column-content">
                <UserMenu user={user} currentUser={currentUser} {...props} />
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
}

UserInformationTable.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.string.isRequired,
    role: PropTypes.shape({
      title: PropTypes.string,
    }),
  }).isRequired,
};
export default UserInformationTable;
